import React from 'react';
import MUIDataTable from "mui-datatables";

import CustomToolbarSelect from '../childrens/customToolbarSelect/.mixins';
import CustomSort from "../childrens/customSort/.mixins";
import {OptionsDefault} from "../../../../../../../../../../../util/optionsTabelaDefault/.mixins";

export default ({
    isLoading,
    dataTodosPedidos,
    dataTodosPedidosIndexSelected,
    columnsTodosPedidos,
    rowsPerPage,
    rowsPerPageOptions,
    page,
    count,
    handlerChangePageTodosPedidos,
    handlerDataTodosPedidosSelected,
    handlerChangeRowsPerPage
}) => {

    const onTableInit = (action, tableState) => {
        changeLabelDisplayRows();
    };

    const changeLabelDisplayRows = () => {
        const value = document.querySelectorAll('#idTableTodosPedidos > div > table > tfoot > tr > td > div > p')[1].innerHTML;
        if (!(value[0] === "M")) {
            document.querySelectorAll('#idTableTodosPedidos > div > table > tfoot > tr > td > div > p')[1].innerHTML = `Mostrando ${value}`;
        }

        //remove label quantidade de linhas selecionadas
        document.querySelectorAll('#idTableTodosPedidos > div > div')[0].style.display = "none";
    };

    return (
        <>
            {!isLoading &&
            <div id={"idTableTodosPedidos"}>
                <MUIDataTable 
                    maxWidth = {"md"}
                    data={dataTodosPedidos} 
                    columns={columnsTodosPedidos}
                    options={{
                        ...OptionsDefault,
                        selectableRows: false,
                        serverSide: true,
                        customSort: CustomSort,
                        customToolbarSelect:(selectedRows, displayData, setSelectedRows) => 
                        <CustomToolbarSelect
                            selectedRows={selectedRows}
                            displayData={displayData}
                            setSelectedRows={setSelectedRows}
                        />,
                        onRowsSelect : (curRowSelected, allRowsSelected) => {
                            if (curRowSelected.length === 0) return;
                            handlerDataTodosPedidosSelected(curRowSelected[0].index);
                        },
                        rowsPerPage,
                        rowsPerPageOptions,
                        page,
                        count,
                        onTableChange: (action, tableState) => {
                            if (action == 'changePage') {
                                handlerChangePageTodosPedidos(tableState.page, tableState.sortOrder);
                            }
                            if (action == 'changeRowsPerPage') {
                                handlerChangeRowsPerPage(tableState.rowsPerPage);
                            }
                            changeLabelDisplayRows();
                        },
                        rowsSelected: dataTodosPedidosIndexSelected,
                        onTableInit: onTableInit,
                        customHeadLabelRender: (columnMeta) => {
                            return (<></>);
                        },
                        selectableRowsHeader: false
                    }} 
                />
            </div>
            } 
        </>
    );
};
